import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-roadmap',
  templateUrl: './roadmap.component.html',
  styleUrl: './roadmap.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoadmapComponent implements OnInit, AfterViewInit {

  isMobile = signal<boolean>(false);
  windowSize: number = 0;
  isRender = signal<boolean>(false);
  slideOption = {
    loop: true,
    autoplay: false,
    mouseDrag: true,
    touchDrag: true,
    dots: false,
    nav: false,
    autoplayTimeout: 2500,
    responsive: {
      0: { items: 1, loop: false },
      577: { items: 1.5, loop: false },
      768: { items: 2.5, loop: true },
      1300: { items: 3.4, loop: true },
    },
  };

  private items: Array<any> = [
    {
      title: "roadmap.phase_1_title",
      time: "roadmap.phase_1_time",
      icon: "completed",
      timing: 'roadmap.phase_1_timing',
      outcome: 'roadmap.phase_1_outcome',
      list: [
        "roadmap.phase_1_point1",
        "roadmap.phase_1_point2",
        "roadmap.phase_1_point3",
        "roadmap.phase_1_point4",
      ]
    },
    {
      title: "roadmap.phase_2_title",
      time: "roadmap.phase_2_time",
      icon: "upcoming",
      timing: "roadmap.phase_2_timing",
      outcome: 'roadmap.phase_2_outcome',
      list: [
        "roadmap.phase_2_point1",
        "roadmap.phase_2_point2",
        "roadmap.phase_2_point3",
        "roadmap.phase_2_point4",
      ]
    },
    {
      title: "roadmap.phase_3_title",
      time: "roadmap.phase_3_time",
      icon: "upcoming",
      timing: "roadmap.phase_3_timing",
      outcome: 'roadmap.phase_3_outcome',
      list: [
        "roadmap.phase_3_point1",
        "roadmap.phase_3_point2",
        "roadmap.phase_3_point3",
        "roadmap.phase_3_point4",
      ]
    },
    {
      title: "roadmap.phase_4_title",
      time: "roadmap.phase_4_time",
      icon: "upcoming",
      timing: "roadmap.phase_4_timing",
      outcome: 'roadmap.phase_4_outcome',
      list: [
        "roadmap.phase_4_point1",
      ]
    },
    {
      title: "roadmap.phase_5_title",
      time: "roadmap.phase_5_time",
      icon: "upcoming",
      timing: "roadmap.phase_5_timing",
      outcome: 'roadmap.phase_5_outcome',
      list: [
        "roadmap.phase_5_point1",
        "roadmap.phase_5_point2",
        "roadmap.phase_5_point3",
        "roadmap.phase_5_point4",
      ]
    },
  ];
  translatedItems = signal<any[]>([])

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private translateService: TranslateService,
  ) { }

  ngOnInit(): void {
    this.translateService.onLangChange.subscribe(() => {
      this.translateItems();
    });
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.windowSize = window.innerWidth;
      this.isMobile.set(this.windowSize <= 1024);
      this.isRender.set(true);
      this.translateItems();
    }
  }

  trackByIndex(index: number) {
    return index;
  }

  private translateItems(): void {
    const translatedItems: any[] = this.items.map(item => ({
      ...item,
      title: this.translateService.instant(item.title),
      time: this.translateService.instant(item.time),
      timing: this.translateService.instant(item.timing),
      outcome: this.translateService.instant(item.outcome),
      list: item.list.map((key: string) => this.translateService.instant(key)),
    }));

    this.translatedItems.set(translatedItems);
  }

}
